export default "__VITE_ASSET__zdQlPwqW__"